import './App.css';
import Plans from './components/Plans/Plans';

function App() {
  return (
    <>
      <Plans />
    </>
  );
}

export default App;
